import { render, staticRenderFns } from "./policy-holder-form.vue?vue&type=template&id=762af519&scoped=true&"
import script from "./policy-holder-form.vue?vue&type=script&lang=js&"
export * from "./policy-holder-form.vue?vue&type=script&lang=js&"
import style0 from "./policy-holder-form.vue?vue&type=style&index=0&id=762af519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762af519",
  null
  
)

export default component.exports